import React from 'react';
import { DisclaimerParagraph } from './DisclaimerText.styles';

export default function DisclaimerText({ children }: React.PropsWithChildren) {
  return (
    <section>
      <article className="mt-2xl flex justify-center md:mt-4xl">
        <DisclaimerParagraph className="max-w-[1056px]">
          {children}
        </DisclaimerParagraph>
      </article>
    </section>
  );
}
